<template>
  <el-dialog
    :title="$t('text.add_lora_network')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    append-to-body
    :modal-append-to-body="false"
    @close="closeDialog()"
    width="400px"
  >
    <div>
      <el-form
        label-width="110px"
        :model="form"
        ref="form"
        label-position="top"
      >
        <el-form-item
          :label="$t('text.application_id')"
          prop="ApplicationId"
          :rules="[
            {
              required: true,
              message: this.$t('text.please_enter_application_id'),
              trigger: 'blur'
            }
          ]"
        >
          <el-input
            v-model="form.ApplicationId"
            autocomplete="off"
            :placeholder="$t('text.application_id')"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="linkLoRaNetwork()"
        :loading="loading"
        >{{ $t('text.add').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        ApplicationId: ''
      }
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        ApplicationId: ''
      }
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    linkLoRaNetwork() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.LinkLoRaNetwork(
            this.$store.getters[`user/selecteOrganisationId`],
            this.form.ApplicationId
          )
            .then(response => {
              this.loading = false
              if (response.data.success) {
                swal({
                  icon: 'success',
                  timer: 2000,
                  title: this.$t('text.add_lora_network_successful')
                })
                this.$emit('success')
                this.closeDialog()
              } else {
                swal({
                  icon: 'warning',
                  timer: 2000,
                  title: this.$t('text.failed'),
                  text: response.data.msg + '.'
                })
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>
